<template>
  <div id="index">
    <div style="text-align:left;padding-left:10px;">
      ２．辛さ初期登録
    </div>
    <v-stepper v-model="stepper" v-show="!isLoading">
      <v-stepper-header id="header">
        <v-stepper-step :complete="stepper > 1" step="1">食品選択</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="stepper > 2" step="2">辛さランキング登録</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :complete="stepper > 3" step="3">登録確認</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card flat>
            <p>１．食べたことがある食品をタップしてください</p>
            <v-layout row wrap style="min-height:450px;">
              <v-flex xs4 v-for="(food, id) in foods" :key=id>
                <v-card style="margin:3px;border:2px solid #f44336;"
                  @click="onClick(id)"
                >
                  <v-img
                    :src="food.imageurl"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <v-container fill-height fluid pa-2>
                      <v-layout style="display:table;">
                        <v-flex xs12 style="display:table-cell;vertical-align:middle;">
                          <v-icon v-show="food.isSelect" size="50" color="green" style="background:#fff; border-radius:30px;">check_circle</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <div style="display:table;font-size:100%;height:50px;width:100%;" class="primary--text">
                    <div style="display:table-cell;vertical-align:middle;">
                      {{food.name | textTrim(13)}}
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-btn @click="onNext" block dark large color="red">次へ</v-btn>
            <v-btn outline block :to="{name: 'home'}">辛さ比較の登録をスキップする</v-btn>
            <p>※スキップしてもマイページから登録できます。</p>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-card>
            <p>２．辛いと思う順でタップしてください</p>
            <v-layout v-show="!isLoading" row wrap>
              <v-flex xs4 v-for="(food, id) in foodsSelected" :key=id>
                <v-card style="margin:3px;border:2px solid #f44336;"
                  @click="onRankClick(id)"
                >
                  <v-img
                    :src="food.imageurl"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <v-container fill-height fluid pa-2>
                      <v-layout style="">
                        <v-spacer></v-spacer>
                        <div style="padding-top:12px;">
                          <div v-show="food.rank>0"
                            style="font-size:20pt;padding-top:4px;
                                  background:#4CAF50;color:#fff;border:5px solid #fff;
                                  width:55px;height:55px;border-radius:30px;"
                          >{{food.rank}}</div>
                        </div>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <div style="display:table;font-size:100%;height:50px;width:100%;" class="primary--text">
                    <div style="display:table-cell;vertical-align:middle;">
                      {{food.name | textTrim(13)}}
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-btn @click="onFinSecound" block dark large color="red">次へ</v-btn>
            <v-btn @click="resetRank" block outline large color="red">やり直す</v-btn>
          </v-card>
        </v-stepper-content>
        <v-stepper-content step="3">
          <v-card>
            <p>３．あなたのカライモノランクです！こちらで登録します！！ </p>
            <v-layout v-show="!isLoading" row wrap>
              <v-flex xs4 v-for="(food, id) in foodsSelected" :key=id>
                <v-card style="margin:3px;border:2px solid #f44336;">
                  <v-img
                    :src="food.imageurl"
                    aspect-ratio="1"
                    class="grey lighten-2"
                  >
                    <v-container fill-height fluid pa-2>
                      <v-layout style="">
                        <v-spacer></v-spacer>
                        <div style="padding-top:12px;">
                          <div v-show="food.rank>0"
                            style="font-size:20pt;padding-top:4px;
                                  background:#F44336;color:#fff;border:5px solid #fff;
                                  width:55px;height:55px;border-radius:30px;"
                          >{{food.rank}}</div>
                        </div>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-container>
                  </v-img>
                  <div style="display:table;font-size:100%;height:50px;width:100%;" class="primary--text">
                    <div style="display:table-cell;vertical-align:middle;">
                      {{food.name | textTrim(13)}}
                    </div>
                  </div>
                </v-card>
              </v-flex>
            </v-layout>
            <v-btn @click="onSubmit" block dark large color="red">
              <div v-if="isSending">
                <v-progress-circular
                  indeterminate
                  color="white"
                ></v-progress-circular>
              </div>
              <span v-else>登録する</span>
            </v-btn>
            <v-btn @click="goStart" block outline large color="red">最初からやり直す</v-btn>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <div v-show="isLoading" style="text-align:center;height:400x;padding-top:150px;">
      <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
    </div>
  </div>
</template>

<script>
// import CommonHeader from '@/components/common/CommonHeader.vue'
// import BreadCrumbs from '@/components/common/BreadCrumbs.vue'
import { db } from '@/main'
import getImageUrl from '@/assets/js/getImageUrl.js'
export default {
  name: 'SearchFood',
  data () {
    return {
      isLoading: false,
      isSending: false,
      foods: [],
      foodsSelectedRank: [],
      stepper: 0,
      rank: 0
    }
  },
  computed: {
    foodsSelected () {
      let foodsSelected = []
      this.foods.forEach(food => {
        if (food.isSelect) {
          foodsSelected.push(food)
        }
      })
      return foodsSelected
    },
    user () {
      return this.$store.state.user
    }
  },
  filters: {
    textTrim: function (value, max) {
      if (value.length >= max) return value.substring(0, max - 1) + '...'
      return value
    }
  },
  watch: {
  },
  created () {
    this.getFood()
  },
  mounted () {
    let obj = {
      group: 'messageTop',
      type: 'success',
      title: 'ご利用ありがとうございます！！',
      text: `辛さ比較を登録して、辛さ比較ライフをはじめましょう！`
    }
    this.$emit('onMessage', obj)
  },
  methods: {
    async onSubmit () {
      if (this.isSending) return
      let obj = this.makeSendData()
      this.isSending = true
      await db.collection('rank').doc(this.user.uid).set(obj, {merge: true})
      let message = {
        group: 'messageBottom',
        type: 'success',
        title: 'Thank you !!',
        text: `${this.user.displayName}さんのカライモノランキングを登録しました！`
      }
      this.$emit('onMessage', message)
      this.isSending = false
      this.$router.push({name: 'home'})
    },
    makeSendData () {
      let timestamp = new Date()
      let list = []
      this.foodsSelectedRank.forEach(f => {
        let foodObj = {
          id: f.id,
          name: f.name,
          timestamp: timestamp
        }
        if (f.images) foodObj.images = f.images
        if (f.category) foodObj.category = f.category
        list.push(foodObj)
      })

      let obj = {
        foods: list,
        user: this.user,
        timestamp: timestamp
      }
      return obj
    },
    async getFood () {
      this.isLoading = true
      // テストデータでとりあえず
      let response = await db.collection('food').orderBy('famousScore', 'desc').limit(9).get()
      response.forEach(doc => {
        let food = doc.data()
        food.id = doc.id
        food.imageurl = getImageUrl.get('food_thumbs', food.id, food.images[0])
        food.isSelect = false
        food.rank = 0
        this.foods.push(food)
      })
      this.isLoading = false
    },
    onClick (id) {
      this.foods[id].isSelect = !this.foods[id].isSelect
    },
    onNext () {
      let flag = false
      for (let i = 0; i < this.foods.length; i++) {
        if (this.foods[i].isSelect) {
          flag = true
          break
        }
      }
      if (flag) {
        this.stepper=2
        window.scrollTo(0, 0)
      } else {
        let message = {
          group: 'messageTop',
          type: 'warning',
          text: `食品が選択されていません`
        }
        this.$emit('onMessage', message)
      }
    },
    onRankClick (id) {
      if (this.rank > 0 && this.foodsSelected[id].rank === this.rank) {
        // 同じ商品を連続タップ⇒やり直し
        this.foodsSelected[id].rank = 0
        this.rank--
      } else if (this.foodsSelected[id].rank > 0) {
        let obj = {
          group: 'messageBottom',
          type: 'warning',
          title: '既に選択済です。',
          text: '別の商品をタップするか、やり直すを選択してください。'
        }
        this.$emit('onMessage', obj)
      } else {
        this.rank++
        this.foodsSelected[id].rank = this.rank
      }
    },
    resetRank () {
      this.foods.forEach(food => {
        food.rank = 0
      })
      this.rank = 0
    },
    resetSelect () {
      this.foods.forEach(food => {
        food.isSelect = false
      })
    },
    onFinSecound () {
      this.stepper = 3
      window.scrollTo(0, 0)
      this.foodsSelectedRank = this.foodsSelected
      this.foodsSelectedRank.sort(function(a, b) {
        if (a.rank < b.rank) return -1
        if (a.rank > b.rank) return 1
        return 0
      })
    },
    goStart () {
      this.resetRank()
      this.resetSelect()
      this.stepper = 1
    }
  },
  components: {
    // CommonHeader,
    // BreadCrumbs
  },
  head: {
    title () {
      return {
        inner: '辛さ比較初期登録',
        separator: ' ',
        complement: 'カライイネ'
      }
    },
    meta () {
      return [
        {name: 'description', content: '辛さの初期設定です。'}
      ]
    },
    link () {
      return [
        {rel: 'canonical', href: 'https://karaiine.jp/'}
      ]
    }
  }
}
</script>

<style scoped>
  #index{
    min-height:90vh;
    text-align:center;
  }
</style>